import Model, { AsyncBelongsTo, belongsTo } from '@ember-data/model';

import type LocaleModel from 'admin-panel/models/locale';
import type RoomControlTvChannelModel from 'admin-panel/models/room-control/tv-channel';

export default class RoomControlTvChannelLocaleModel extends Model {
  @belongsTo('locale')
  declare locale: AsyncBelongsTo<LocaleModel>;

  @belongsTo('room-control/tv-channel')
  declare roomControlTvChannel: AsyncBelongsTo<RoomControlTvChannelModel>;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'room-control/tv-channel-locale': RoomControlTvChannelLocaleModel;
  }
}
